import AppScreen from 'components/AppScreen'
import { ModalProvider } from 'react-modal-hook'

export default function PublicContainer({ children }) {
  return (
    <ModalProvider>
      <AppScreen>{children}</AppScreen>
    </ModalProvider>
  )
}
